module.exports = __webpack_public_path__ + "static/media/about-certificate-img9.8cc531d9.jpg";